import { Component, OnInit } from '@angular/core';
import { About } from '../../models/about';
import { AboutService } from '../../services/about-service';
import { BaseComponent } from '../../../../shared/Components/base/base.component';
import { Router } from '@angular/router';
import { NbToastrService } from '@nebular/theme';
import { uploadService } from '../../../../shared/uploadService';
import { combineLatest, of } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { FileVm } from '../../../../shared/Models/fileVm';

@Component({
  selector: 'about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss'],
})
export class AboutComponent extends BaseComponent implements OnInit {
  models: About[] = [];
  attachments: any = new FormData();
  uploadingVideo: boolean = false;
  isloading: boolean = false;
  constructor(service: AboutService,
    route: Router,
    private toast: NbToastrService,
    private uploadService: uploadService) {
    super(route, service, null);
    this.pagingModel.query.pageSize = 50;
  }

  ngOnInit() {
    this.service.get(this.pagingModel.query).subscribe((res) => {
      this.initiResponse(res);
      this.finishLoading = true;
      if (this.pagingModel.responseObj != undefined && this.pagingModel.responseObj.length) {
        let entity = this.pagingModel.responseObj.find((a) => a.key == 'creation');
        this.models.push({
          id: entity.id,
          key: 'creation',
          descriptionAR: entity.descriptionAR,
          descriptionEN: entity.descriptionEN,
          titleAR: 'نشأة المجمع',
          titleEN: 'نشأة المجمع'
        });

        entity = this.pagingModel.responseObj.find((a) => a.key == 'Chairman-of-the-Board-of-Trustees');

        this.models.push({
          id: entity.id,
          key: 'Chairman-of-the-Board-of-Trustees',
          descriptionAR: entity.descriptionAR,
          descriptionEN: entity.descriptionEN,
          titleAR: 'كلمة رئيس مجلس الأمناء',
          titleEN: 'كلمة رئيس مجلس الأمناء'
        });

        entity = this.pagingModel.responseObj.find((a) => a.key == 'Secretary-General-speech');

        this.models.push({
          id: entity.id,
          key: 'Secretary-General-speech',
          descriptionAR: entity.descriptionAR,
          descriptionEN: entity.descriptionEN,
          titleAR: 'كلمة الأمين العام',
          titleEN: 'كلمة الأمين العام'
        });

        entity = this.pagingModel.responseObj.find((a) => a.key == 'vision');

        this.models.push({
          id: entity.id,
          key: 'vision',
          descriptionAR: entity.descriptionAR,
          descriptionEN: entity.descriptionEN,
          titleAR: '  الرؤية',
          titleEN: '  الرؤية'
        });

        entity = this.pagingModel.responseObj.find((a) => a.key == 'message');

        this.models.push({
          id: entity.id,
          key: 'message',
          descriptionAR: entity.descriptionAR,
          descriptionEN: entity.descriptionEN,
          titleAR: '  الرسالة',
          titleEN: '  الرسالة'
        });

        entity = this.pagingModel.responseObj.find((a) => a.key == 'objective');

        this.models.push({
          id: entity.id,
          key: 'objective',
          descriptionAR: entity.descriptionAR,
          descriptionEN: entity.descriptionEN,
          titleAR: 'الأهداف',
          titleEN: 'الأهداف'
        });

        entity = this.pagingModel.responseObj.find((a) => a.key == 'values');

        this.models.push({
          id: entity.id,
          key: 'values',
          descriptionAR: entity.descriptionAR,
          descriptionEN: entity.descriptionEN,
          titleAR: 'القيم',
          titleEN: 'القيم'
        });

        entity = this.pagingModel.responseObj.find((a) => a.key == 'strategic_direction');

        this.models.push({
          id: entity.id,
          key: 'strategic_direction',
          descriptionAR: entity.descriptionAR,
          descriptionEN: entity.descriptionEN,
          titleAR: 'التوجه الاستراتيجي للمجمع',
          titleEN: 'التوجه الاستراتيجي للمجمع'
        });

        entity = this.pagingModel.responseObj.find((a) => a.key == 'attachments');
        this.uploadService.updateFiles({ files: [], previousAttachments: entity.attachments });
        this.models.push({
          id: entity.id,
          key: "attachments",
          descriptionAR: '',
          descriptionEN: '',
          titleAR: '',
          titleEN: '',
          attachments: entity.attachments,
          videoPath: entity.videoPath,
          images: entity.images
        });

      } else {
        this.models.push({
          key: 'creation',
          descriptionAR: '',
          descriptionEN: '',
          titleAR: 'نشأة المجمع',
          titleEN: 'نشأة المجمع'
        });

        this.models.push({
          key: 'Chairman-of-the-Board-of-Trustees',
          descriptionAR: '',
          descriptionEN: '',
          titleAR: 'كلمة رئيس مجلس الأمناء',
          titleEN: 'كلمة رئيس مجلس الأمناء'
        });

        this.models.push({
          key: 'Secretary-General-speech',
          descriptionAR: '',
          descriptionEN: '',
          titleAR: 'كلمة الأمين العام',
          titleEN: 'كلمة الأمين العام'
        });

        this.models.push({
          key: 'vision',
          descriptionAR: '',
          descriptionEN: '',
          titleAR: '  الرؤية',
          titleEN: '  الرؤية'
        });

        this.models.push({
          key: 'message',
          descriptionAR: '',
          descriptionEN: '',
          titleAR: '  الرسالة',
          titleEN: '  الرسالة'
        });

        this.models.push({
          key: 'objective',
          descriptionAR: '',
          descriptionEN: '',
          titleAR: 'الأهداف',
          titleEN: 'الأهداف',
        });

        this.models.push({
          key: 'values',
          descriptionAR: '',
          descriptionEN: '',
          titleAR: 'القيم',
          titleEN: 'القيم',
        });

        this.models.push({
          key: 'strategic_direction',
          descriptionAR: '',
          descriptionEN: '',
          titleAR: 'التوجه الاستراتيجي للمجمع',
          titleEN: 'التوجه الاستراتيجي للمجمع',
        });
        this.models.push({
          key: "attachments",
          descriptionAR: '',
          descriptionEN: '',
          titleAR: '',
          titleEN: '',
          videoPath: '',
          images: [],
          attachments: []
        });
      }
    });
  }

  get isFormValid() {
    const checker = []
    this.models.forEach((a) => {
      if (!a.descriptionAR || a.descriptionAR.trim() === '') {
        checker.push(false);
      }
      else checker.push(true);
    });
    // console.log('isValid', checker.some((a) => a == true));
    // console.log (this.models)
    return checker.some((a) => a == true);
  }


  uploadFile(files: FileVm[]) {
    console.log('uploadFile');
    if(files && files.length > 0) {
    for (let file of files) {
      this.attachments.append(file.fileName, file);
    }
  }
  }

  uploadVideo(evt: any) {
    this.uploadingVideo = true;
    // this.attachments = new FormData();
    let newAttachments = new FormData();
    for (let file of evt) {
      newAttachments.append(file.name, file);
    }

    this.service.uploadFile(newAttachments).subscribe(
      (res) => {
        this.models.forEach(model => {

          if (model.key === 'attachments') {
            model.videoPath = res.fileName;
          }

        });
        this.uploadingVideo = false;
      },
      (error) => {
        this.uploadingVideo = false;
      }
    );
  }

  save() {
    // this.isloading = true;
    const attachments$ = this.uploadService.uploadMultipleFiles();

    combineLatest([attachments$])
      .pipe(
        catchError(() => {
          console.log('error here in combine latest ');
          return of([null]);
        }),
        switchMap(([attachments]) => {
          // Update the model with the uploaded image and attachments

          let isFormDataEmpty = true;
          this.models.forEach((model) => {
            if (model.key === 'attachments') {
              if (attachments && attachments.length > 0) {
                isFormDataEmpty = false;
              }
            }
          });

          if (!isFormDataEmpty) {

            this.models.map(model => {
              if (model.key === 'attachments') {
                model.attachments = attachments;
              }
            });
          }
          else {
            this.models.map(model => {
              if (model.key === 'attachments') {
                model.attachments = [];
              }
            });
          }
          if (!this.models.some((model) => model.key === 'attachments' &&
            this.pagingModel.responseObj && this.pagingModel.responseObj.length > 0)) {
            this.models.push({
              key: 'attachments',
              videoPath: '',
              images: [],
              titleAR: '',
              titleEN: '',
              descriptionAR: '',
              descriptionEN: '',
              attachments: attachments
            });
            return this.service.post(this.models, '/bulk');
          }

          if (this.pagingModel.responseObj && this.pagingModel.responseObj.length > 0) {
            return this.service.putBulk(this.models, 'bulk');
          } else {
            return this.service.post(this.models, '/bulk');
          }
        })
      )
      .subscribe(res => {
        this.toast.show('تم الحفظ بنجاح', '', { status: 'success', duration: 3000 });
        // this.isloading = false;

      });
  }

  public fontColor: object = {
    mode: 'Picker' // Enables a full color picker
  };

}
